import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  MenuItem,
  Menu,
  SwipeableDrawer,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
  Typography,
  ListItemButton,
  Box,
  Skeleton,
} from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';

import LoggedRoutes from 'js/containers/Routes/LoggedRoutes';
import HomeTriibos from 'js/containers/Home/HomeTriibos';
import HomeTriibosSuggestion from 'js/containers/Home/HomeTriibosSuggestion';
import HomeImage from 'js/containers/Home/HomeImage';
import HomeTriibosCarousel from 'js/containers/Home/HomeTriibosCarousel';
//import DownloadApp from 'js/containers/Home/DownloadApp';
import Footer from 'js/containers/Footer/Footer';
import SearchBar from 'js/containers/Search/SearchBar';
import Loading from 'js/containers/Loading/Loading';
// import DownloadAppModal from "js/containers/Drawer/DownloadAppModal";
import LoginModal from 'js/containers/Login/LoginModal';

import { trackEventMatomo } from 'js/library/utils/helpers';
import { useAuth } from 'js/contexts/AuthContext';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import { getUserOrgs } from 'js/library/utils/API/getUserOrgs.js';
import { getSeuClube } from 'js/library/utils/API/getSeuClube';

import thumbWhite from 'styles/assets/thumb_white.webp';
import Profile_Avatar from 'styles/assets/avatar/Profile_Avatar.webp';
import { avatar } from 'styles/avatar';
import { getUserPoints } from 'js/library/utils/API/getUserPoints.js';
import { LanguageSwitcher } from './languageSwitcher';
// import { getBalance } from 'js/library/utils/API/getBalance';
import cfac22 from 'js/library/utils/cfac22';
import {
  HouseLine,
  Wallet,
  ChatText,
  List as MenuIcon,
  SignIn,
  User,
  Files,
  Headset,
  SignOut,
  Info,
  Question,
  Briefcase,
  QrCode as QrCodeIcon,
} from '@phosphor-icons/react';

export default function PrimarySearchAppBar() {
  const { t } = useTranslation('app');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawerOpened, setDrawerOpened] = React.useState(false);
  const [authenticated, setAuthenticated] = React.useState(false);
  const [points, setPoints] = React.useState(null);
  const [pointsLoading, setPointsLoading] = React.useState(false);
  const [orgs, reloadOrgs] = React.useState(false);
  const [userOrgs, setUserOrgs] = React.useState(false);
  const loadedUserOrgsKeyRef = React.useRef(null);
  const userOrgsRequestIdRef = React.useRef(0);
  const [openState, setOpenState] = React.useState(false);
  const [isLoggingOut, setIsLoggingOut] = React.useState(false);
  const location = useLocation();
  const { authState, logout } = useAuth();
  const { userInfo, loading: userInfoLoading } = useCurrentUserInfo();
  const isLandingPage = location.pathname.startsWith('/landing/');
  const [infosSeuClube, setInfosSeuClube] = React.useState(null);
  const isPuckHome =
    location.pathname === '/' &&
    infosSeuClube?.homeLandingPage?.type === 'pucklp' &&
    infosSeuClube?.homeLandingPage?.landingPageId;
  const isFullwidthPage = isLandingPage || isPuckHome;
  const isMeusDados = /^\/meusDados\/?$/.test(location.pathname);
  const userOrgsKey = userInfo?.uId || userInfo?.guestId || userInfo?.triiboId || null;

  const isMenuOpen = Boolean(anchorEl);

  const isGuest = !authState.authData;

  useEffect(() => {
    getSeuClube(null, 'home')
      .then((clubInfo) => setInfosSeuClube(clubInfo))
      .catch((error) => {
        console.error('Erro ao carregar dados do clube:', error);
      });
  }, []);

  useEffect(() => {
    if (userInfoLoading) {
      return undefined;
    }

    if (!userOrgsKey) {
      userOrgsRequestIdRef.current += 1;
      loadedUserOrgsKeyRef.current = null;
      setUserOrgs(null);
      return undefined;
    }

    if (!orgs && loadedUserOrgsKeyRef.current === userOrgsKey) {
      return undefined;
    }

    const requestId = userOrgsRequestIdRef.current + 1;
    userOrgsRequestIdRef.current = requestId;
    setUserOrgs(false);

    getUserOrgs(true)
      .then((result) => {
        if (requestId !== userOrgsRequestIdRef.current) return;

        loadedUserOrgsKeyRef.current = userOrgsKey;
        if (result.success) {
          setUserOrgs(result.userOrgsInfo);
        } else {
          setUserOrgs(null);
        }

        if (orgs) {
          reloadOrgs(false);
        }
      })
      .catch((error) => {
        if (requestId !== userOrgsRequestIdRef.current) return;

        console.error('Error fetching user organizations:', error);
        setUserOrgs(null);

        if (orgs) {
          reloadOrgs(false);
        }
      });

    return () => {
      userOrgsRequestIdRef.current += 1;
    };
  }, [orgs, userInfoLoading, userOrgsKey]);

  const styles = {
    grow: { flexGrow: 1 },
    menuButton: { mr: 2 },
    title: {
      display: { xs: 'none', sm: 'block' },
      mr: 2,
    },
    sectionDesktop: {
      display: { xs: 'none', md: 'flex' },
      width: '100%',
    },
    sectionIcons: {
      display: 'flex',
      width: '80%',
      placeContent: 'center',
      alignItems: 'center',
      gap: '20px',
    },
    sectionAvatar: {
      display: 'flex',
    },
    sectionMobile: {
      display: { xs: 'flex', md: 'none' },
    },
    drawer: {
      width: 240,
    },
  };

  useEffect(() => {
    if (!authState.authData) {
      setAuthenticated(authState.guestData || false);
      setPoints(null);
      setPointsLoading(false);
      return;
    }

    setAuthenticated(authState.authData);

    if (userInfoLoading || !userInfo) {
      setPoints(null);
      setPointsLoading(true);
      return;
    }

    if (isGuest || !userInfo.uId || !userInfo.triiboId) {
      setPoints(0);
      setPointsLoading(false);
      return;
    }

    let active = true;
    setPoints(null);
    setPointsLoading(true);

    getUserPoints(userInfo.triiboId)
      .then((pointsReceived = {}) => {
        if (active) {
          setPoints(pointsReceived.points ?? 0);
          setPointsLoading(false);
        }
      })
      .catch(() => {
        if (active) {
          setPoints(0);
          setPointsLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [authState.authData, authState.guestData, isGuest, userInfo, userInfoLoading]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    trackEventMatomo('Menu', 'tocar', 'botao', 'menu hamburguer');
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setDrawerOpened(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpened(false);
  };

  const thumb =
    !userInfo || userInfo.thumbnail === undefined ? Profile_Avatar : avatar[userInfo.thumbnail];
  const userName = userInfo?.aliasName || 'Triiber';
  const userPointsText =
    points === 1
      ? t('nav_bar.total_user_points')
      : t('nav_bar.total_user_points_plural', {
          points: points ?? 0,
        });
  const userPointsContent = pointsLoading ? (
    <Skeleton
      animation="wave"
      height={20}
      width={118}
      sx={{ bgcolor: 'rgba(255, 255, 255, 0.28)' }}
    />
  ) : (
    <Typography component="span" variant="body2" sx={{ color: 'inherit' }}>
      {userPointsText}
    </Typography>
  );

  const openGuestModal = () => {
    setDrawerOpened(false);
    setAnchorEl(null);
    setOpenState(true);
  };

  const handleQrCodeAccess = (e) => {
    if (isGuest) {
      e?.preventDefault();
      trackEventMatomo('Menu', 'tocar', 'botao', 'modal leitor de qr code');
      openGuestModal();
      return;
    }
    trackEventMatomo('Menu', 'tocar', 'botao', 'leitor de qr code');
    setDrawerOpened(false);
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    if (isLoggingOut) return; // Previne múltiplos cliques

    setIsLoggingOut(true);
    trackEventMatomo('Menu', 'tocar', 'botao', 'sair');

    const result = await logout();

    if (!result?.success) {
      setIsLoggingOut(false);
    }
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <h3>Mais</h3>
      <div>
        {isGuest ? (
          <MenuItem>
            <Link
              to="#"
              style={{
                textDecoration: 'none',
                color: '#6D3195',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => {
                openGuestModal();
                trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil');
              }}
            >
              <SignIn size={20} weight="regular" />
              {t('drawer.my_profile')}
            </Link>
          </MenuItem>
        ) : (
          <MenuItem>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil')}
              to="/meusDados"
              style={{
                textDecoration: 'none',
                color: '#6D3195',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <User size={20} weight="regular" />
              {t('drawer.my_profile')}
            </Link>
          </MenuItem>
        )}
        <MenuItem>
          <Link
            onClick={handleQrCodeAccess}
            to="/leitor-qrcode"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <QrCodeIcon size={20} weight="regular" />
            Leitor de QR Code
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'o que é a triibo')}
            to="/sobre"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Info size={20} weight="regular" />
            {t('drawer.what_is_triibo')}
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'como usar')}
            to="/como-usar"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Question size={20} weight="regular" />
            {t('drawer.how_to_use')}
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            target="_blank"
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'solucoes para empresas')}
            to="https://triibo.com.br/triibo-negocios/"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Briefcase size={20} weight="regular" />
            {t('drawer.solutions_triibo')}
          </Link>
        </MenuItem>
      </div>
      <div>
        <MenuItem>
          <Link
            onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'fale conosco')}
            to="/fale-conosco"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Headset size={20} weight="regular" />
            {t('drawer.contact_us')}
          </Link>
        </MenuItem>
        <MenuItem>
          <a
            href={document.location.origin + '/termos-de-uso-dos-servicos-triibo/'}
            target="new"
            style={{
              textDecoration: 'none',
              color: '#6D3195',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Files size={20} weight="regular" />
            {t('drawer.terms_and_policies')}
          </a>
        </MenuItem>
        {isGuest ? (
          <MenuItem>
            <Link
              to="/login"
              style={{
                textDecoration: 'none',
                color: '#6D3195',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <SignIn size={20} weight="regular" />
              <strong>Iniciar Sessão</strong>
            </Link>
          </MenuItem>
        ) : (
          <MenuItem onClick={handleLogout} disabled={isLoggingOut}>
            <Link
              component="span"
              style={{
                textDecoration: 'none',
                color: isLoggingOut ? '#999' : '#6D3195',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                cursor: isLoggingOut ? 'not-allowed' : 'pointer',
                opacity: isLoggingOut ? 0.5 : 1,
              }}
            >
              <SignOut size={20} weight="regular" />
              <strong>{isLoggingOut ? 'Saindo...' : t('drawer.exit')}</strong>
            </Link>
          </MenuItem>
        )}
      </div>

      {/* MODAL PARA BAIXAR APP TRIIBO */}
      {/* <DownloadAppModal /> */}
    </Menu>
  );

  const renderMenuMobile = (
    <ul className="menu-mobile">
      <li>
        <Link to="/" onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Home App')}>
          <IconButton aria-label="home" color="primary">
            <HouseLine
              size={30}
              weight={location.pathname === '' || location.pathname === '/' ? 'fill' : 'light'}
            />
          </IconButton>
        </Link>
      </li>
      {isGuest ? (
        <>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Caixa de Entrada')}
              to="#"
            >
              <IconButton
                onClick={() => openGuestModal()}
                aria-label="Notificações"
                color="primary"
              >
                <ChatText
                  size={30}
                  weight={
                    location.pathname === '/caixaDeEntrada' ||
                    location.pathname === '/caixaDeEntrada/'
                      ? 'fill'
                      : 'light'
                  }
                />
              </IconButton>
            </Link>
          </li>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Minha Carteira')}
              to="#"
            >
              <IconButton
                onClick={() => openGuestModal()}
                aria-label="Minha carteira"
                color="primary"
              >
                <Wallet
                  size={30}
                  weight={
                    location.pathname === '/carteira' || location.pathname === '/carteira/'
                      ? 'fill'
                      : 'light'
                  }
                />
              </IconButton>
            </Link>
          </li>
        </>
      ) : (
        <>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Caixa de Entrada')}
              to="/caixaDeEntrada"
            >
              <IconButton aria-label="Notificações" color="primary">
                <ChatText
                  size={30}
                  weight={
                    location.pathname === '/caixaDeEntrada' ||
                    location.pathname === '/caixaDeEntrada/'
                      ? 'fill'
                      : 'light'
                  }
                />
              </IconButton>
            </Link>
          </li>
          <li>
            <Link
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Minha Carteira')}
              to="/carteira"
            >
              <IconButton aria-label="Minha carteira" color="primary">
                <Wallet
                  size={30}
                  weight={
                    location.pathname === '/carteira' || location.pathname === '/carteira/'
                      ? 'fill'
                      : 'light'
                  }
                />
              </IconButton>
            </Link>
          </li>
        </>
      )}
      <li>
        <Link onClick={handleQrCodeAccess} to="/leitor-qrcode">
          <IconButton aria-label="leitor de qr code" color="primary">
            <QrCodeIcon
              size={30}
              weight={location.pathname.indexOf('/leitor-qrcode') === 0 ? 'fill' : 'light'}
            />
          </IconButton>
        </Link>
      </li>
      <li>
        <IconButton aria-label="show more" color="primary" onClick={handleDrawerOpen}>
          <MenuIcon size={30} />
        </IconButton>
      </li>
    </ul>
  );

  const renderDrawer = (
    <SwipeableDrawer
      anchor="left"
      open={drawerOpened}
      onClose={handleDrawerClose}
      onOpen={handleDrawerOpen}
    >
      <Box sx={styles.drawer} role="presentation" onClick={handleDrawerClose}>
        <div
          style={{
            backgroundColor: '#eee',
            justifyContent: 'flex-end',
            alignContent: 'center',
            display: 'flex',
          }}
        >
          <IconButton aria-label="voltar" color="primary" onClick={handleDrawerClose}>
            <ChevronLeft style={{ color: '#000' }} />
          </IconButton>
        </div>
        <List>
          {isGuest ? (
            <ListItemButton style={{ padding: 0 }}>
              <Link
                to="#"
                onClick={() => {
                  openGuestModal();
                  trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil');
                }}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <SignIn size={20} weight="regular" />
                {t('drawer.my_profile')}
              </Link>
            </ListItemButton>
          ) : (
            <ListItemButton style={{ padding: 0 }}>
              <Link
                onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'meu perfil')}
                to="/meusDados"
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <User size={20} weight="regular" />
                {t('drawer.my_profile')}
              </Link>
            </ListItemButton>
          )}
          <ListItemButton style={{ padding: 0 }}>
            <Link
              onClick={handleQrCodeAccess}
              to="/leitor-qrcode"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <QrCodeIcon size={20} weight="regular" />
              Leitor de QR Code
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/sobre"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'o que é a triibo')}
            >
              <Info size={20} weight="regular" />
              {t('drawer.what_is_triibo')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/como-usar"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'como usar')}
            >
              <Question size={20} weight="regular" />
              {t('drawer.how_to_use')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="https://triibo.com.br/triibo-negocios/"
              target="_blank"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'Solucoes para negocios')}
            >
              <Briefcase size={20} weight="regular" />
              {t('drawer.solutions_triibo')}
            </Link>
          </ListItemButton>

          <ListItemButton style={{ padding: 0 }}>
            <Link
              to="/fale-conosco"
              target="new"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'fale conosco')}
            >
              <Headset size={20} weight="regular" />
              {t('drawer.contact_us')}
            </Link>
          </ListItemButton>
          <ListItemButton style={{ padding: 0 }}>
            <a
              href={document.location.origin + '/termos-de-uso-dos-servicos-triibo/'}
              target="new"
              style={{
                width: '100%',
                padding: '8px 16px',
                color: '#000',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onClick={() => {
                trackEventMatomo('Menu', 'tocar', 'botao', 'termos e políticas de uso');
              }}
            >
              <Files size={20} weight="regular" />
              {t('drawer.terms_and_policies')}
            </a>
          </ListItemButton>
          {isGuest ? (
            <ListItemButton style={{ width: '100%', padding: 0, color: '#000' }}>
              <Link
                to="/login"
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  color: '#000',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <SignIn size={20} weight="regular" />
                <strong>Iniciar Sessão</strong>
              </Link>
            </ListItemButton>
          ) : (
            <ListItemButton
              onClick={handleLogout}
              disabled={isLoggingOut}
              style={{
                width: '100%',
                padding: '8px 16px',
                color: isLoggingOut ? '#999' : '#000',
                cursor: isLoggingOut ? 'not-allowed' : 'pointer',
                opacity: isLoggingOut ? 0.5 : 1,
              }}
            >
              <Link
                component="span"
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                <SignOut size={20} weight="regular" />
                <strong>{isLoggingOut ? 'Saindo...' : t('drawer.exit')}</strong>
              </Link>
            </ListItemButton>
          )}
        </List>
      </Box>
    </SwipeableDrawer>
  );

  if (authenticated === false) {
    return (
      <div className="loading-login">
        <Loading />
      </div>
    );
  } else if (authenticated === null) {
    //window.location = document.location.origin;
    return (
      <div className="loading-login">
        <Loading />
      </div>
    );
  } else {
    return (
      <Box sx={styles.grow}>
        <LoginModal openState={openState} setOpenState={setOpenState} />

        <AppBar>
          <div className="container-topbar">
            <Toolbar>
              <Link onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'logo')} to="/">
                <Box component="img" src={thumbWhite} alt="logo" width="45px" sx={styles.title} />
              </Link>
              <SearchBar />

              <Box sx={styles.sectionDesktop}>
                <Box sx={styles.sectionIcons}>
                  {isGuest ? (
                    <>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'home')}
                        to="/"
                      >
                        <IconButton>
                          <HouseLine
                            size={40}
                            weight={
                              location.pathname === '' || location.pathname === '/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() =>
                          trackEventMatomo('Menu', 'tocar', 'botao', 'caixa de entrada')
                        }
                        to="#"
                      >
                        <IconButton onClick={() => openGuestModal()}>
                          <ChatText
                            size={40}
                            weight={
                              location.pathname === '/caixaDeEntrada' ||
                              location.pathname === '/caixaDeEntrada/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'carteira')}
                        to="#"
                      >
                        <IconButton onClick={() => openGuestModal()}>
                          <Wallet
                            size={40}
                            weight={
                              location.pathname === '/carteira' ||
                              location.pathname === '/carteira/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'home')}
                        to="/"
                      >
                        <IconButton>
                          <HouseLine
                            size={40}
                            weight={
                              location.pathname === '' || location.pathname === '/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() =>
                          trackEventMatomo('Menu', 'tocar', 'botao', 'caixa de entrada')
                        }
                        to="/caixaDeEntrada"
                      >
                        <IconButton>
                          <ChatText
                            size={40}
                            weight={
                              location.pathname === '/caixaDeEntrada' ||
                              location.pathname === '/caixaDeEntrada/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                      <Link
                        onClick={() => trackEventMatomo('Menu', 'tocar', 'botao', 'carteira')}
                        to="/carteira"
                      >
                        <IconButton>
                          <Wallet
                            size={40}
                            weight={
                              location.pathname === '/carteira' ||
                              location.pathname === '/carteira/'
                                ? 'fill'
                                : 'light'
                            }
                            color="white"
                          />
                        </IconButton>
                      </Link>
                    </>
                  )}
                </Box>

                <Box sx={styles.sectionAvatar}>
                  {isGuest ? (
                    // TROCAR
                    <Link
                      style={{
                        minWidth: '120px',
                        cursor: 'pointer',
                        textDecoration: 'none',
                      }}
                      to="/login"
                    >
                      <ListItem style={{ minWidth: '120px' }}>
                        <ListItemText
                          style={{ lineHeight: '2.3vh' }}
                          primary={
                            <span style={{ fontWeight: 'bold', color: 'white' }} width="120px">
                              {t('drawer.click_here')}
                            </span>
                          }
                          secondary={
                            <Typography variant="body2" style={{ color: 'white' }}>
                              {t('drawer.signUp')}
                            </Typography>
                          }
                        />
                      </ListItem>
                    </Link>
                  ) : (
                    <ListItem style={{ minWidth: '120px' }}>
                      <ListItemAvatar>
                        <Avatar alt="avatar" src={thumb} />
                      </ListItemAvatar>
                      {/* <ListItemText style={{ lineHeight: '2.3vh' }} primary={<span style={{ fontWeight: 'bold' }} width='120px'>Olá {userInfo.aliasName ? userInfo.aliasName : 'Triiber'},</span>} secondary={<span style={{ color: 'white' }}>Você tem {points} pontos</span>} /> */}
                      <ListItemText
                        style={{ lineHeight: '2.3vh' }}
                        primary={
                          <Typography variant="body2" style={{ fontWeight: 'bold' }} width="120px">
                            {t('nav_bar.hello')}, {userName},
                          </Typography>
                        }
                        secondary={
                          <Typography
                            component="div"
                            variant="body2"
                            sx={{
                              minHeight: 20,
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {userPointsContent}
                          </Typography>
                        }
                      />
                    </ListItem>
                  )}
                  <LanguageSwitcher />
                  <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                    // style={{ marginLeft: '10px' }}
                  >
                    <MenuIcon size={40} />
                  </IconButton>
                </Box>
              </Box>
            </Toolbar>
          </div>
        </AppBar>
        {renderMenu}
        {renderMenuMobile}
        {renderDrawer}

        <main
          className={`main${isFullwidthPage ? ' landing-main' : ''}${
            isMeusDados ? ' meusDados-main' : ''
          }`}
        >
          {isMeusDados ? (
            <div className="meusDados-fullpage">
              <LoggedRoutes setOpenState={setOpenState} reloadOrgs={reloadOrgs} />
            </div>
          ) : (
            <>
              {!isFullwidthPage && (
                <div className="container" style={{ backgroundColor: '#fff' }}>
                  <HomeTriibosCarousel userOrgs={userOrgs} />
                </div>
              )}
              <div className="container">
                <Grid container spacing={4} style={{ paddingBottom: 10 }}>
                  <Grid size={{ md: isFullwidthPage ? 12 : 8, xs: 12 }}>
                    <LoggedRoutes setOpenState={setOpenState} reloadOrgs={reloadOrgs} />
                  </Grid>
                  {!isFullwidthPage && (
                    <Grid
                      size={{ md: 4, xs: 12 }}
                      style={{
                        height: 0,
                        marginTop: 0,
                        marginBottom: 0,
                        padding: 0,
                      }}
                    ></Grid>
                  )}
                </Grid>
              </div>
              {!isFullwidthPage && (
                <div className="home-side-container" style={{ height: 0 }}>
                  <div className="container" style={{ height: 0 }}>
                    <Grid
                      container
                      spacing={4}
                      style={{
                        height: 0,
                        marginTop: 0,
                        marginBottom: 0,
                        padding: 0,
                      }}
                    >
                      <Grid
                        size={{ md: 8, xs: 12 }}
                        style={{
                          height: 0,
                          marginTop: 0,
                          marginBottom: 0,
                          padding: 0,
                        }}
                      ></Grid>
                      <Grid size={{ md: 4, xs: 12 }}>
                        <div className="home-side-content">
                          <HomeImage />
                          <HomeTriibos orgs={orgs} userOrgs={userOrgs} />
                          <HomeTriibosSuggestion orgs={orgs} />
                          {/* <DownloadApp /> */}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              )}
            </>
          )}
          <Footer />
        </main>
      </Box>
    );
  }
}
